import { Action, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";

import { StateType } from "../../../../utils/types";
import { getVideo, deleteVideo } from "../../../../redux/educator/actions";
import {
  selectVideos,
  selectVideosLoading,
} from "../../../../redux/educator/selector";

const mapStateToProps = (state: StateType) => ({
  videos: selectVideos(state),
  loading: selectVideosLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  actions: bindActionCreators(
    {
      getVideo,
      deleteVideo,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps);
